import React from "react";
import Typewriter from "typewriter-effect";
import { FaGithub, FaLinkedin } from "react-icons/fa";

export const Header = () => {
  return (
    <section className="relative min-h-[100vh] flex flex-col justify-center items-center bg-white px-6 text-center overflow-hidden select-none">
      {/* Animated Magic Blobs */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 w-96 h-96 bg-gradient-to-r from-pink-300 via-purple-200 to-indigo-300 opacity-40 rounded-full blur-[120px] animate-pulse-slow" />
        <div className="absolute bottom-1/4 left-1/2 transform -translate-x-1/2 w-96 h-96 bg-gradient-to-r from-yellow-200 via-green-200 to-cyan-300 opacity-40 rounded-full blur-[120px] animate-pulse-slow delay-3000" />
      </div>

      {/* Floating Hero Content */}
      <div className="relative z-10 flex flex-col items-center animate-float">
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight leading-tight mb-6 bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 bg-clip-text text-transparent drop-shadow-[0_0_15px_rgba(255,105,180,0.5)]">I Code With Purpose.</h1>

        <h2 className="text-xl md:text-2xl mb-6 min-h-[56px] font-semibold tracking-wide text-gray-700">
          <Typewriter
            options={{
              strings: ["<span class='text-pink-500'>Fullstack Developer</span>", "<span class='text-purple-500'>Clean code. Elegant solutions.</span>", "<span class='text-indigo-500'>Built for impact, designed to last.</span>"],
              autoStart: true,
              loop: true,
              delay: 80,
              deleteSpeed: 40,
              cursor: "▌",
            }}
          />
        </h2>

        <p className="text-gray-600 max-w-xl text-center text-lg leading-relaxed font-light mb-8">Full Stack Engineer building web and mobile apps from scratch. Expert in React, Flutter, Node.js, and PHP. Crafting scalable, offline-capable systems and elegant solutions that last.</p>

        {/* Social Icons */}
        <div className="flex justify-center gap-8 text-3xl md:text-4xl mt-5">
          <SocialIcon href="https://github.com/Tsheko777/" icon={<FaGithub />} color="#333" hoverColor="#6e5494" />
          <SocialIcon href="https://www.linkedin.com/in/tshekokutumela/" icon={<FaLinkedin />} color="#0077B5" hoverColor="#005582" />
        </div>
      </div>

      <style jsx>{`
        .animate-pulse-slow {
          animation: pulse 8s ease-in-out infinite;
        }
        @keyframes pulse {
          0%,
          100% {
            transform: scale(1);
            opacity: 0.3;
          }
          50% {
            transform: scale(1.1);
            opacity: 0.5;
          }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        @keyframes float {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-8px);
          }
        }
      `}</style>
    </section>
  );
};

const SocialIcon = ({ href, icon, color, hoverColor }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" style={{ color }} className="transition-transform duration-300 transform hover:scale-125 hover:drop-shadow-xl">
    {icon}
  </a>
);
